export class FieldValueModel {
    public fieldValueId = 0;
    public fieldId = 0;
    public value: any = null;
}
